import React from 'react';
import Cookies from 'universal-cookie';
import { getConfig } from '@edx/frontend-platform';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';

import LocationSelector from '../location-selector';
import WelcomeModalLogo from './images/modal-logo.svg';
import messages from './messages';

const WelcomeBanner = ({ intl }) => {
  const cookieKey = getConfig().USER_COUNTRY_CODE_COOKIE_NAME || 'user_country_code';
  const cookies = new Cookies();

  if (cookies.get(cookieKey)) {
    return null;
  }

  return (
    <div className="welcome-modal-wrapper">
      <div className="welcome-modal">
        <img
          className="welcome-modal-logo"
          src={WelcomeModalLogo}
          alt={intl.formatMessage(messages.logoAlt)}
        />
        <LocationSelector
          displayControls
          displayTitle
        />
      </div>
    </div>
  );
};

WelcomeBanner.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(WelcomeBanner);
